export default __webpack_public_path__ + "static/media/MINUS.7ce51a96.svg";